import { Building2 } from 'lucide-react'
import { useState } from 'react'
import { firstUrl } from '../../utils/format'

type LogoStatus = 'loading' | 'loaded' | 'failed'

function websiteDomain(website: string): string | null {
  const normalizedUrl = firstUrl(website)
  if (!normalizedUrl) return null

  try {
    const url = new URL(normalizedUrl)
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return null

    const domain = url.hostname.toLowerCase().replace(/^www\./, '')
    return domain.includes('.') ? domain : null
  } catch {
    return null
  }
}

function LogoFallback() {
  return <Building2 className="lead-logo-fallback" data-testid="lead-logo-fallback" size={18} />
}

function WebsiteLogoImage({ faviconUrl }: { faviconUrl: string }) {
  const [status, setStatus] = useState<LogoStatus>('loading')

  return (
    <span className="lead-website-logo" data-testid="lead-website-logo" aria-hidden="true">
      {status === 'loaded' ? null : <LogoFallback />}
      {status === 'failed' ? null : (
        <img
          className={status === 'loaded' ? 'is-loaded' : ''}
          data-testid="lead-website-favicon"
          src={faviconUrl}
          alt=""
          width={40}
          height={40}
          loading="lazy"
          decoding="async"
          onLoad={() => setStatus('loaded')}
          onError={() => setStatus('failed')}
        />
      )}
    </span>
  )
}

export function LeadWebsiteLogo({ website }: { website: string }) {
  const domain = websiteDomain(website)

  if (!domain) {
    return (
      <span className="lead-website-logo" data-testid="lead-website-logo" aria-hidden="true">
        <LogoFallback />
      </span>
    )
  }

  const faviconUrl = `https://www.google.com/s2/favicons?domain=${encodeURIComponent(domain)}&sz=256`
  return <WebsiteLogoImage faviconUrl={faviconUrl} key={faviconUrl} />
}
